module.exports = __webpack_public_path__ + "media/13-4.41fd6630.mp3";